module.exports = __webpack_public_path__ + "img/50-50-az.11c29dd6.svg";